import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import '../css/Admin_css/admin-customize.css';
import COLORS from '../resources/colors/COLORS';
import MyLoader from '../Spinner/MyLoader';

const MdlFeePayDetails = ({ show = true, actionClose, pay_details = [] }) => {
  const [modalShow, setModalShow] = useState(show);
  const [Loading, setLoading] = useState(false);

  useEffect(() => {
    setModalShow(show);
  }, [show]);

  const handleClose = () => {
    setModalShow(false);
    if (actionClose) {
      actionClose();
    }
  };

  if (!pay_details || pay_details.length === 0) {
    return null;
  }

  const details = pay_details[0] || {};

  const formatAmount = (amount) => {
    const num = parseFloat(amount) || 0;
    return num.toLocaleString('en-IN');
  };

  return (
    <Modal
      show={modalShow}
      onHide={handleClose}
      animation={false}
      size="sm"
      aria-labelledby="pay-details-title"
      centered
      backdrop="static"
      backdropClassName="custom-backdrop"
      contentClassName="custom-modal-content"
      style={{
        borderRadius: "20px",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          background: COLORS.white,
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
          border: "none",
          display: "flex",
          flexDirection: "column",
          maxHeight: "90vh",
        }}
      >
        <Modal.Header
          closeButton
          style={{
            background: `linear-gradient(135deg, ${COLORS.primary_color_shade7 || "#01579B"} 0%, ${COLORS.primary_color_shade8 || "#0277BD"} 100%)`,
            color: COLORS.white,
            border: "none",
            padding: "16px 20px",
            position: "relative",
            overflow: "hidden",
            flexShrink: 0,
          }}
        >
          <div style={{ position: "relative", zIndex: 1, width: "100%" }}>
            <Modal.Title
              id="pay-details-title"
              style={{
                fontSize: "20px",
                fontWeight: "700",
                margin: 0,
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <i className="fa fa-info-circle" style={{ fontSize: "18px" }}></i>
              Payment Details
            </Modal.Title>
          </div>
        </Modal.Header>

        <Modal.Body
          style={{
            padding: "20px",
            background: `linear-gradient(to bottom, ${COLORS.grey1 || "#F5F5F5"} 0%, ${COLORS.white} 100%)`,
            border: "none",
            overflowY: "auto",
            overflowX: "hidden",
            flex: "1 1 auto",
            maxHeight: "calc(90vh - 180px)",
          }}
        >
          {Loading ? (
            <MyLoader />
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              {/* Primary Cards - Amount Paid and Current Due */}
              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                {/* Amount Paid Card */}
                <div
                  style={{
                    background: `linear-gradient(135deg, ${COLORS.green4 || "#2C8D02"} 0%, ${COLORS.green_dark || "#33b536"} 100%)`,
                    borderRadius: "12px",
                    padding: "20px",
                    boxShadow: "0 4px 12px rgba(76, 175, 80, 0.2)",
                    color: COLORS.white,
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "-20px",
                      right: "-20px",
                      width: "100px",
                      height: "100px",
                      background: "rgba(255, 255, 255, 0.1)",
                      borderRadius: "50%",
                    }}
                  />
                  <div style={{ position: "relative", zIndex: 1 }}>
                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        color: COLORS.white,
                        marginBottom: "8px",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
                      }}
                    >
                      <i className="fa fa-check-circle" style={{ fontSize: "14px", color: COLORS.white }}></i>
                      Amount Paid
                    </div>
                    <div
                      style={{
                        fontSize: "28px",
                        fontWeight: "700",
                        color: COLORS.white,
                        display: "flex",
                        alignItems: "baseline",
                        gap: "4px",
                        textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
                      }}
                    >
                      <span style={{ fontSize: "20px", color: COLORS.white }}>₹</span>
                      {formatAmount(details.total_recieved || 0)}
                    </div>
                  </div>
                </div>

                {/* Current Due Card */}
                <div
                  style={{
                    background: `linear-gradient(135deg, ${COLORS.red7 || "#d32f2f"} 0%, ${COLORS.card_red || "#F44336"} 100%)`,
                    borderRadius: "12px",
                    padding: "20px",
                    boxShadow: "0 4px 12px rgba(244, 67, 54, 0.2)",
                    color: COLORS.white,
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "-20px",
                      right: "-20px",
                      width: "100px",
                      height: "100px",
                      background: "rgba(255, 255, 255, 0.1)",
                      borderRadius: "50%",
                    }}
                  />
                  <div style={{ position: "relative", zIndex: 1 }}>
                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        color: COLORS.white,
                        marginBottom: "8px",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
                      }}
                    >
                      <i className="fa fa-exclamation-circle" style={{ fontSize: "14px", color: COLORS.white }}></i>
                      Current Due
                    </div>
                    <div
                      style={{
                        fontSize: "28px",
                        fontWeight: "700",
                        color: COLORS.white,
                        display: "flex",
                        alignItems: "baseline",
                        gap: "4px",
                        textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
                      }}
                    >
                      <span style={{ fontSize: "20px", color: COLORS.white }}>₹</span>
                      {formatAmount(details.current_due || 0)}
                    </div>
                  </div>
                </div>
              </div>

              {/* Secondary Cards - Total Fee, Total Due, Settled */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: "12px",
                }}
              >
                {/* Total Fee */}
                <div
                  style={{
                    background: `linear-gradient(135deg, ${COLORS.primary_color_shade1 || "#B3E5FC"} 0%, ${COLORS.white} 100%)`,
                    borderRadius: "12px",
                    padding: "16px",
                    boxShadow: "0 4px 12px rgba(1, 87, 155, 0.15)",
                    border: `2px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "-15px",
                      right: "-15px",
                      width: "60px",
                      height: "60px",
                      background: "rgba(79, 195, 247, 0.1)",
                      borderRadius: "50%",
                    }}
                  />
                  <div style={{ position: "relative", zIndex: 1 }}>
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: COLORS.primary_color_shade7 || "#01579B",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        marginBottom: "6px",
                      }}
                    >
                      <div
                        style={{
                          width: "28px",
                          height: "28px",
                          borderRadius: "8px",
                          background: `linear-gradient(135deg, ${COLORS.primary_color_shade3 || "#4FC3F7"}, ${COLORS.primary_color_shade5 || "#03A9F4"})`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: COLORS.white,
                          fontSize: "12px",
                        }}
                      >
                        <i className="fa fa-file-text-o"></i>
                      </div>
                      <span>Total Fee</span>
                    </div>
                    <div
                      style={{
                        fontSize: "22px",
                        fontWeight: "700",
                        color: COLORS.primary_color_shade7 || "#01579B",
                        display: "flex",
                        alignItems: "baseline",
                        gap: "4px",
                      }}
                    >
                      <span style={{ fontSize: "18px" }}>₹</span>
                      {formatAmount(details.total_fee || 0)}
                    </div>
                  </div>
                </div>

                {/* Total Due */}
                <div
                  style={{
                    background: `linear-gradient(135deg, ${COLORS.radish1 || "#FFCDD2"} 0%, ${COLORS.white} 100%)`,
                    borderRadius: "12px",
                    padding: "16px",
                    boxShadow: "0 4px 12px rgba(244, 67, 54, 0.15)",
                    border: `2px solid ${COLORS.card_red || "#F44336"}`,
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "-15px",
                      right: "-15px",
                      width: "60px",
                      height: "60px",
                      background: "rgba(244, 67, 54, 0.1)",
                      borderRadius: "50%",
                    }}
                  />
                  <div style={{ position: "relative", zIndex: 1 }}>
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: COLORS.card_red || "#F44336",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        marginBottom: "6px",
                      }}
                    >
                      <div
                        style={{
                          width: "28px",
                          height: "28px",
                          borderRadius: "8px",
                          background: `linear-gradient(135deg, ${COLORS.card_red || "#F44336"}, ${COLORS.red6 || "#e53935"})`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: COLORS.white,
                          fontSize: "12px",
                        }}
                      >
                        <i className="fa fa-calendar-times-o"></i>
                      </div>
                      <span>Total Due</span>
                    </div>
                    <div
                      style={{
                        fontSize: "22px",
                        fontWeight: "700",
                        color: COLORS.card_red || "#F44336",
                        display: "flex",
                        alignItems: "baseline",
                        gap: "4px",
                      }}
                    >
                      <span style={{ fontSize: "18px" }}>₹</span>
                      {formatAmount(details.total_due || 0)}
                    </div>
                  </div>
                </div>

                {/* Settled */}
                <div
                  style={{
                    background: `linear-gradient(135deg, ${COLORS.green_light || "#C8E6C9"} 0%, ${COLORS.white} 100%)`,
                    borderRadius: "12px",
                    padding: "16px",
                    boxShadow: "0 4px 12px rgba(76, 175, 80, 0.15)",
                    border: `2px solid ${COLORS.green_dark || "#4CAF50"}`,
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "-15px",
                      right: "-15px",
                      width: "60px",
                      height: "60px",
                      background: "rgba(76, 175, 80, 0.1)",
                      borderRadius: "50%",
                    }}
                  />
                  <div style={{ position: "relative", zIndex: 1 }}>
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: COLORS.green_dark || "#4CAF50",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        marginBottom: "6px",
                      }}
                    >
                      <div
                        style={{
                          width: "28px",
                          height: "28px",
                          borderRadius: "8px",
                          background: `linear-gradient(135deg, ${COLORS.green_dark || "#4CAF50"}, ${COLORS.green4 || "#2C8D02"})`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: COLORS.white,
                          fontSize: "12px",
                        }}
                      >
                        <i className="fa fa-handshake-o"></i>
                      </div>
                      <span>Settled</span>
                    </div>
                    <div
                      style={{
                        fontSize: "22px",
                        fontWeight: "700",
                        color: COLORS.green_dark || "#4CAF50",
                        display: "flex",
                        alignItems: "baseline",
                        gap: "4px",
                      }}
                    >
                      <span style={{ fontSize: "18px" }}>₹</span>
                      {formatAmount(details.due_settlement || 0)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer
          style={{
            borderTop: `1px solid ${COLORS.grey3 || "#E0E0E0"}`,
            padding: "12px 20px",
            background: COLORS.white,
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            flexShrink: 0,
          }}
        >
          <Button
            onClick={handleClose}
            style={{
              background: COLORS.primary_color_shade7 || "#01579B",
              border: "none",
              padding: "8px 24px",
              borderRadius: "8px",
              fontSize: "14px",
              fontWeight: "600",
              color: COLORS.white,
              transition: "all 0.2s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = COLORS.primary_color_shade8 || "#0277BD";
              e.currentTarget.style.transform = "translateY(-1px)";
              e.currentTarget.style.boxShadow = "0 4px 8px rgba(1, 87, 155, 0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = COLORS.primary_color_shade7 || "#01579B";
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <i className="fa fa-check" style={{ marginRight: "6px" }}></i>
            OK
          </Button>
        </Modal.Footer>
      </div>

      {/* Custom CSS for scrollbar and modal overrides */}
      <style>{`
        .custom-backdrop {
          background-color: rgba(0, 0, 0, 0.6);
          backdrop-filter: blur(4px);
        }
        .custom-modal-content {
          border-radius: 20px;
          overflow: visible;
          border: none;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          display: flex;
          flex-direction: column;
          max-height: 90vh;
        }
        .modal-content {
          border-radius: 20px;
          overflow: visible;
          border: none;
        }
        .modal-dialog {
          margin: 1.75rem auto;
          max-width: 500px;
          width: 90vw;
          max-height: 90vh;
          display: flex;
          flex-direction: column;
        }
        .modal.show .modal-dialog {
          transform: none;
        }
        .modal-header {
          border-radius: 20px 20px 0 0;
        }
        .modal-footer {
          border-radius: 0 0 20px 20px;
        }
        .modal-header .btn-close {
          filter: brightness(0) invert(1);
          opacity: 0.9;
          z-index: 2;
        }
        .modal-header .btn-close:hover {
          opacity: 1;
        }
        /* Custom scrollbar for modal body */
        .modal-body::-webkit-scrollbar {
          width: 8px;
        }
        .modal-body::-webkit-scrollbar-track {
          background: ${COLORS.grey1};
          border-radius: 10px;
        }
        .modal-body::-webkit-scrollbar-thumb {
          background: ${COLORS.primary_color_shade3};
          border-radius: 10px;
        }
        .modal-body::-webkit-scrollbar-thumb:hover {
          background: ${COLORS.primary_color_shade5};
        }
      `}</style>
    </Modal>
  );
};

export default MdlFeePayDetails;
